import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: "transparent",
    padding: "4px 16px",
    "&:focus": {
      backgroundColor: "transparent",
    },
  },
  customSelect: {
    borderRadius: "1000px !important",
    backgroundColor: "transparent",
    border: "1px solid transparent",
    height: 40,
    width: "100%",
    "&:hover": {
      border: `1px solid ${theme.palette.inventoryFilterHover}`,
    },
  },
  selected: {
    "&.Mui-selected": {
      backgroundColor: theme.palette.bkg.hover.black.light,
      "&:hover": {
        backgroundColor: theme.palette.bkg.hover.black.light,
      },
    },
  },
}));
